/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AppointmentState } from '@appointments/store/appointment.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectAppointmentState = createFeatureSelector<AppointmentState>('appointments');

export const getAppointments = createSelector(selectAppointmentState, state => state.appointments);
export const isAppointmentActionPending = createSelector(selectAppointmentState, state => state.isActionPending);
export const getCurrentAppointment = createSelector(selectAppointmentState, state => state.currentAppointment);
